import { z } from "zod";

export const MachineEventReasonSlugSchema = z
  .string()
  .regex(/^[a-z][a-z0-9_]*$/, "slug em snake_case ASCII");

export const MachineEventReasonSchema = z.object({
  slug: MachineEventReasonSlugSchema,
  displayName: z.string().min(1).max(120),
  category: z.string().min(1).max(60).nullable(),
  isActive: z.boolean(),
  sortOrder: z.number().int().min(0),
});
export type MachineEventReason = z.infer<typeof MachineEventReasonSchema>;

export const ListMachineEventReasonsQuerySchema = z.object({
  isActive: z
    .enum(["true", "false"])
    .optional()
    .default("true")
    .transform((v) => v === "true"),
});
export type ListMachineEventReasonsQuery = z.infer<typeof ListMachineEventReasonsQuerySchema>;

export const ListMachineEventReasonsResponseSchema = z.object({
  data: z.array(MachineEventReasonSchema),
});
export type ListMachineEventReasonsResponse = z.infer<typeof ListMachineEventReasonsResponseSchema>;

export const ListMachineEventReasonsEnvelopeSchema = z.object({
  data: ListMachineEventReasonsResponseSchema.shape.data,
  error: z.null(),
});
